export function requestHeader() {
  // Définis le header des requetes
  const token = JSON.parse(localStorage.getItem("access"));
  if (token) {
    return { Authorization: `Bearer ${token.trim()}` };
  } else {
    return {};
  }
}
